import _styled from "@emotion/styled-base";
import React from 'react';
import PropTypes from 'prop-types';
import Tag from "../Tag";
import Box from "../Box";

var StyledUnorderedList = _styled("ul", {
  target: "e1ooo6d30",
  label: "StyledUnorderedList"
})("padding-left:0;margin:0;> li + li{&:before{content:'", function (props) {
  return props.separator;
}, "';}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1RhZ3MvVGFncy5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTXFDIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1RhZ3MvVGFncy5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBUYWcgZnJvbSAnLi4vVGFnJztcbmltcG9ydCBCb3ggZnJvbSAnLi4vQm94JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuY29uc3QgU3R5bGVkVW5vcmRlcmVkTGlzdCA9IHN0eWxlZC51bGBcbiAgcGFkZGluZy1sZWZ0OiAwO1xuICBtYXJnaW46IDA7XG4gID4gbGkgKyBsaSB7XG4gICAgJjpiZWZvcmUge1xuICAgICAgY29udGVudDogJyR7KHByb3BzKSA9PiBwcm9wcy5zZXBhcmF0b3J9JztcbiAgICB9XG4gIH1cbmA7XG5cbmNvbnN0IFRhZ3MgPSAocHJvcHMpID0+IChcbiAgPEJveCBtbD17cHJvcHMubWx9IHB5PXswfT5cbiAgICA8U3R5bGVkVW5vcmRlcmVkTGlzdCBzZXBhcmF0b3I9XCIgJiMxMTgyNTsgXCI+XG4gICAgICB7cHJvcHMuY2hpbGRyZW59XG4gICAgPC9TdHlsZWRVbm9yZGVyZWRMaXN0PlxuICA8L0JveD5cbik7XG5cblRhZ3MucHJvcFR5cGVzID0ge1xuICBjaGlsZHJlbjogUHJvcFR5cGVzLm5vZGUsXG4gIG1sOiBQcm9wVHlwZXMubnVtYmVyLFxufTtcblxuVGFncy5kZWZhdWx0UHJvcHMgPSB7XG4gIG1sOiAwLFxufTtcblxuVGFncy5UYWcgPSBUYWc7XG5cbmV4cG9ydCBkZWZhdWx0IFRhZ3M7XG4iXX0= */"));

var Tags = function Tags(props) {
  return /*#__PURE__*/React.createElement(Box, {
    ml: props.ml,
    py: 0
  }, /*#__PURE__*/React.createElement(StyledUnorderedList, {
    separator: " \u2E31 "
  }, props.children));
};

Tags.propTypes = {
  children: PropTypes.node,
  ml: PropTypes.number
};
Tags.defaultProps = {
  ml: 0
};
Tags.Tag = Tag;
export default Tags;